import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Tooltip title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          color: 'var(--text-secondary)',
          transition: 'all 0.3s ease',
          '&:hover': {
            color: 'var(--primary-500)',
            backgroundColor: 'var(--bg-hover)',
            transform: 'rotate(12deg)',
          },
        }}
      >
        {isDarkMode ? (
          <LightMode sx={{ fontSize: 22 }} />
        ) : (
          <DarkMode sx={{ fontSize: 22 }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
